// @flow

import styled from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

export const ErrorLabel = styled.span`
  color: ${theme.colors.error(51)};
  font-size: 0.9rem;
  font-weight: bold;
  margin-top: 0.1rem;
`;
